import React, {useCallback} from "react";
import Checkbox, {CheckboxClickEvent} from "@/ui/Checkbox";
import DatePicker from '@/ui/DateComponents/DatePicker/DatePicker';
import {isMobileView} from "@/lib/picos/browserFns";
import FormElement from "./FormElement";
import type {BaseFormElementProps} from "./types";
import ErrorBoundaryO from "@/ErrorBoundary/ErrorBoundaryO";

interface DateWithCheckboxProps extends BaseFormElementProps {
    disabled: boolean;
    onCheckboxClicked: CheckboxClickEvent;
    onDateChanged: (date: Date) => void;
    data?: any;
}

export const DateWithCheckbox: React.FC<DateWithCheckboxProps> = ({
                                                                      uiParent,
                                                                      paramName,
                                                                      uiLabel,
                                                                      current,
                                                                      disabled,
                                                                      onCheckboxClicked,
                                                                      onDateChanged,
                                                                      data
                                                                  }) => {
    const handleClick: CheckboxClickEvent = useCallback((e, data) => {
        onCheckboxClicked(e, data);
    }, [onCheckboxClicked]);

    const value = current[paramName];
    const date = value ? new Date(value) : null;
    const checked = !!date;

    if (isMobileView()) {
        return (
            <ErrorBoundaryO uniqueKey={`form-element-date-checkbox-${paramName}`} shouldUseErrorIcon={true}>
                <div className="Row ClassWithDate" id={`${uiLabel}${paramName}`}>
                    <div className="FormComponentValue">
                        <Checkbox checked={checked}
                                  onClick={handleClick}
                                  disabled={disabled}
                                  label={uiLabel}
                                  data={data}
                        />
                        {value && (
                            <DatePicker name={paramName}
                                        onChange={onDateChanged}
                                        defaultValue={date}
                            />
                        )}
                    </div>
                </div>
            </ErrorBoundaryO>
        );
    }

    return (
        <FormElement
            uiParent={uiParent}
            paramName={paramName}
            uiLabel={uiLabel}
            value={
                <>
                    <Checkbox
                        checked={checked}
                        onClick={handleClick}
                        disabled={disabled}
                        label={paramName}
                        hideLabel={true}
                        data={data}
                    />
                    {value && (
                        <DatePicker
                            name={paramName}
                            onChange={onDateChanged}
                            defaultValue={date}
                        />
                    )}
                </>
            }
        />
    );
};

export default DateWithCheckbox;
